export default __webpack_public_path__ + "images/icons/ic_message.svg";